import { renderInDocument } from '@spotahome/soyuz/client';

import ReferAFriendContainer from './main';

renderInDocument(ReferAFriendContainer);
